import { render, staticRenderFns } from "./ClienteMenuRight.vue?vue&type=template&id=41071bfc"
import script from "./ClienteMenuRight.vue?vue&type=script&lang=js"
export * from "./ClienteMenuRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports